document.addEventListener('DOMContentLoaded', () => {
	// console.log(Swiper);

	let swiper = null;

	function initSwiper() {
		swiper = new Swiper('.staff-slider', {
			slidesPerView: 1,
			spaceBetween: 30,
			pagination: {
				el: ".swiper-pagination",
				type: "progressbar",
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			breakpoints: {
				992: {
					slidesPerView: 2,
				}
			}
		});
	}

	function toggleSwiper(enable) {
		if (swiper !== null) {
			if (enable) {
				swiper.enable();
			} else {
				swiper.disable();
			}
		}
	}

	function handleCtrlKey(event) {
		if (event.key === 'Control') {
			toggleSwiper(!event.ctrlKey);
		}
	}

	document.addEventListener('keydown', handleCtrlKey);
	document.addEventListener('keyup', handleCtrlKey);

	function handleResize() {
		if (window.innerWidth >= 1025) {
			if (swiper === null) {
				initSwiper();
			} else {
				toggleSwiper(true);
			}
		} else {
			initSwiper();
		}
	}

	handleResize();

	window.addEventListener('resize', handleResize);

	if($('#breadcrumbs-placeholder').length) {
		$('.bx-breadcrumb').detach().appendTo('#breadcrumbs-placeholder')
	}

	$('.map-menu-close').click(function () {
		$(this).closest('.map-menu-wrapper').removeClass('opened')
	})


	$(document).on('click', '.sm_state,  .sm_label', function (e) {

		let region = _.lowerCase($(this).data('region'));
		let section = _.lowerCase($(this).data('section'))
		let lang = $('.map-menu-wrapper').data('lang');
		let path = window.location.pathname + window.location.hash;  // Получаем только путь и хэш без хоста и параметров GET

		$.ajax({
			url: '/ajax/map.php',
			data: {'region_code': region, 'lang' : lang, 'section' : section, 'path' : path},
			success: function (res) {
				var data = $.parseJSON(res);
				if (data.regionName && data.currentElement) {
					$(".modal-title").html(data.regionName);
					$('ul.nav-tabs').find('li').remove();
					$('ul.nav-tabs').html(data.menu);
					$('#citiesTabContent').empty().html(data.currentElement);
					$('.map-menu-wrapper').addClass('opened');
				}
			},
			error: function() {
				console.log('error region data');
			}
		});

	})

	$('.map-geography-menu-close').click(function () {
		$(this).closest('.map-geography-menu-wrapper').removeClass('opened')
	})

	// $(document).on('click', '.all_region_state', function (e) {
	// 	let title = ($(this).data('title'));
	// 	$.ajax({
	// 		url: '/ajax/all_region_text.php',
	// 		success: function (res) {
	// 			let data = $.parseJSON(res);
	// 			let HTML = '';
	// 			const regionsTab = document.querySelector('.geography-map-nav');
	// 			regionsTab.innerHTML = '';
	// 			$(".modal-title").html(title);
	//
	// 			Object.keys(data).forEach((dataKey, regionIndex) => {
	// 				let region = data[dataKey];
	// 				let regionTabStart = `
	// 					<li data-v-4e0cbb42="" class="nav-item" role="tab">
    //                             <a data-v-4e0cbb42=""
    //                                id="region-tab-0"
    //                                data-toggle="tab"
    //                                role="tab"
    //                                href="javascript:void(0)"
    //                                aria-controls="region-tab-0"
    //                                aria-selected="true"
    //                                class=""
    //                                data-region="">${dataKey}
    //                             </a>
	// 				`;
	// 				HTML += regionTabStart;
	//
	// 				region.forEach(oneCity => {
	// 					let cityTab = `
	// 							<ul data-v-4e0cbb42="" id="citiesTab" role="tree" class="nav">
    //                                 <li data-v-4e0cbb42="" class="nav-item" role="tab">
    //                                     <a data-v-4e0cbb42=""
    //                                        id="region-tab-0"
    //                                        data-toggle="tab"
    //                                        role="tab"
    //                                        href="#city-0"
    //                                        aria-controls="region-tab-0"
    //                                        aria-selected="true"
    //                                        class="nav-link active"
    //                                        data-city="${oneCity.CODE}">${oneCity.NAME}
    //                                     </a>
    //                                     <div data-v-4e0cbb42="" id="citiesTabContent" class="tab-content" style="position: relative;">
    //                                         ${oneCity.DETAIL_TEXT}
    //                                     </div>
    //                                 </li>
    //                             </ul>
	// 					`;
	// 					HTML += cityTab;
	// 				});
	//
	// 				let regionTabEnd = `
	// 					</li>
	// 				`;
	// 				HTML += regionTabEnd;
	//
	// 				$('.map-geography-menu-wrapper').css('display', 'flex');
	// 				setTimeout(function() {
	// 					$('.map-geography-menu-wrapper').addClass('opened');
	// 				}, 100);
	// 			});
	// 			regionsTab.innerHTML = HTML;
	// 		},
	//
	// 		error: function () {
	// 			console.log('error region data');
	// 		}
	// 	});
	// })

	$(document).on('click', '#citiesTab a', function (e) {
		e.preventDefault();
		let city = _.lowerCase($(this).data('city'))
		let region = _.lowerCase($(this).data('region'))
		let section = _.lowerCase($(this).data('section'))
		let lang = $('.map-menu-wrapper').data('lang');
		let path = window.location.pathname + window.location.hash;  // Получаем только путь и хэш без хоста и параметров GET
		$.ajax({
			url: '/ajax/map.php',
			data: {'city_code': city, 'region_code': region, 'section': section, 'lang': lang, 'path' : path},
			success: function (res) {
				var data = $.parseJSON(res);
				console.log(data);
				$(".modal-title").html(data.regionName);
				$("#citiesTabContent").html(data.currentElement);
				$("#citiesTab").html(data.menu);
				$('#citiesTab a').removeClass('active')
				$(this).addClass('active')
			},
			error: function () {
				console.log('error city data');
			}
		});
	})
});

let fixLabelPosition = function (el, shiftX = 25, shiftY = 0) {

	if (el.attr('data-fixed')) {
		return false
	}
	const str = el.attr('transform')
	if (str) {
		const match = str.match(/matrix\((.*)\)/);
		if (match) {
			const labelTransformValues = match[1];
			let arValues = labelTransformValues.split(',')
			let labelXValue = arValues[arValues.length - 2];
			let labelYValue = arValues[arValues.length - 1];
			labelXValue = parseFloat(labelXValue);
			labelYValue = parseFloat(labelYValue);
			labelXValue = labelXValue + shiftX;
			labelYValue = labelYValue + shiftY;
			arValues[arValues.length - 2] = labelXValue
			arValues[arValues.length - 1] = labelYValue
			el.attr('transform', `matrix(${arValues.join()})`)
			el.attr('data-fixed', 'true')
		}
	}
}
let fixLabelsPositions = function () {
	if (window.outerWidth > 992) {
		fixLabelPosition($('.sm_label_KZ11'), 0, -75) // Акмола
		fixLabelPosition($('.sm_label_KZ35')) //Караганда
		fixLabelPosition($('.sm_label_KZ19'), -15) //Алматы
		fixLabelPosition($('.sm_label_KZ63'), 10) // Казахстан
		fixLabelPosition($('.sm_label_KZ27'), 0, 5) //Западный Казахстан
	} else {
		// akmola
		let screenWidth = window.innerWidth;
		const referenceWidth = 425; // ширина экрана, для которой известно смещение
		const referenceOffset = -60; // смещение при ширине 425px
		fixLabelPosition($('.sm_label_KZ11'), 0, (referenceOffset / referenceWidth) * screenWidth)
		// akmola
		fixLabelPosition($('.sm_label_KZ35'), 15)
		fixLabelPosition($('.sm_label_KZ19'), -17)
	}

}

let fixLabelsPositionsDebounce = _.debounce(fixLabelsPositions, 500)

function addTextNodeToSvg(text, x, y, code = '') {
	// Create an SVG namespace
	const svgNamespace = "http://www.w3.org/2000/svg";

// Create the text element with the SVG namespace
	const textElement = document.createElementNS(svgNamespace, "text");

// Set attributes
	textElement.setAttribute("x", x);
	textElement.setAttribute("y", y);
	textElement.setAttribute("text-anchor", "left");
	textElement.setAttribute("font-size", "9px");
	textElement.setAttribute("font-weight", "bold");
	textElement.setAttribute("font-family", "Arial");
	textElement.setAttribute("fill", "#000");
	textElement.setAttribute("style", "-webkit-tap-highlight-color: rgba(0, 0, 0, 0); cursor: pointer; opacity: 1;");
	// textElement.setAttribute("transform", "matrix(0.808,0,0,0.808,50.0314,43.7484)");
	textElement.setAttribute("class", "sm_label-city sm_label-city-" + code);

// Create a tspan element
	const tspanElement = document.createElementNS(svgNamespace, "tspan");
	// tspanElement.setAttribute("dy", "5.569376045227074");
	tspanElement.setAttribute("style", "-webkit-tap-highlight-color: rgba(0, 0, 0, 0);");
	tspanElement.textContent = text;

// Append the tspan to the text element
	textElement.appendChild(tspanElement);

// Append the text element to the SVG
	document.querySelector("#map_inner svg").appendChild(textElement);
}

let insertCityNames = function () {
	if(window.simplemaps_countrymap_mapdata) {
		const cityData = window.simplemaps_countrymap_mapdata.locations
		Object.keys(cityData).forEach(key => {
			const obj = $(`.sm_location_${key}`)
			const name = cityData[key].name
			let x = parseFloat(obj.attr('x')) + 7
			let y = parseFloat(obj.attr('y')) + 7

			addTextNodeToSvg(name, x, y, key)
		})
	}
}


$(window).on('load resize click', fixLabelsPositionsDebounce)
$('#map').on('mouseover', fixLabelsPositions)
$(window).on('load', function () {
	if(window.simplemaps_countrymap_mapdata) {
		const stateData = window.simplemaps_countrymap_mapdata.state_specific

		Object.keys(stateData).forEach(key => {
			$(`.sm_label_${key}`).attr('fill', stateData[key].textColor)

			$(`.sm_state_${key}`).attr('data-region', stateData[key].code)
			$(`.sm_state_${key}`).attr('data-section', window.simplemaps_countrymap_mapdata.section)

			$(`.sm_label_${key}`).attr('data-region', stateData[key].code)
			$(`.sm_label_${key}`).attr('data-section', window.simplemaps_countrymap_mapdata.section)



		})

	}

	setTimeout(() => {
		insertCityNames()
	}, 1000)
})